import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesSalesVillagePages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesSalesVillagePages;
